import ApiService from "@/core/services/ApiService";
import JwtService from "@/core/services/JwtService";
import { Actions, Mutations } from "@/store/enums/StoreEnums";
import { Module, Action, Mutation, VuexModule } from "vuex-module-decorators";
import { AxiosRequestConfig } from "axios";

export interface Proveedor {
  id: number;
  nombreProveedor: string;
  rutProveedor: string;
  contactoApellido: string;
  contactoNombre: string;
  contactoEmail: string;
  contactoTelefono: string;
  bancoId:string;
  nombreBanco:string;
  tipoCuenta:string;
  numeroCuenta:string;
}

export interface ProveedorInfo {
  errors: unknown;
  proveedor: Proveedor;
  proveedores: Array<Proveedor>;
}

@Module
export default class ProveedorModule
  extends VuexModule
  implements ProveedorInfo
{
  errors = {};
  proveedor = {} as Proveedor;
  proveedores = [] as Array<Proveedor>;

  /**
   * Get current proveedor object
   * @returns Proveedor
   */
  get currentProveedor(): Proveedor {
    return this.proveedor;
  }

  /**
   * Get all proveedores
   * @returns Array<Proveedor>
   */
  get allProveedores(): Array<Proveedor> {
    return this.proveedores;
  }

  /**
   * Get errors
   * @returns array
   */
  get getProveedorErrors() {
    return this.errors;
  }

  @Mutation
  [Mutations.SET_PROVEEDOR_ERROR](error) {
    this.errors = error;
  }

  @Mutation
  [Mutations.SET_PROVEEDOR](proveedor) {
    this.proveedor = proveedor;
  }

  @Mutation
  [Mutations.SET_PROVEEDORES](proveedores) {
    this.proveedores = proveedores;
  }
  @Action
  [Actions.GET_PROVEEDORES]() {
    return ApiService.get(`proveedor/v1/proveedores`)
      .then(({ data }) => {
        this.context.commit(Mutations.SET_PROVEEDORES, data);
      })
      .catch(({ response }) => {
        this.context.commit(
          Mutations.SET_PROVEEDOR_ERROR,
          response.data.errors
        );
      });
  }

  @Action
  [Actions.GET_PROVEEDOR]() {
    return ApiService.get(`proveedor/v1/proveedor`)
      .then(({ data }) => {
        this.context.commit(Mutations.SET_PROVEEDOR, data);
      })
      .catch(({ response }) => {
        this.context.commit(
          Mutations.SET_PROVEEDOR_ERROR,
          response.data.errors
        );
      });
  }

  @Action
  [Actions.GET_PROVEEDOR_RUT](rut) {
    return ApiService.get(`proveedor/v1/proveedor/rut/${rut}`)
      .then(({ data }) => {
        this.context.commit(Mutations.SET_PROVEEDOR, data);
      })
      .catch(({ response }) => {
        this.context.commit(
          Mutations.SET_PROVEEDOR_ERROR,
          response.data.errors
        );
        throw new Error();
      });
  }

  @Action
  [Actions.UPD_PROVEEDOR](params) {
    return ApiService.put(`proveedor/v1/proveedor/${params.id}`, params)
      .then(({ data }) => {
        this.context.commit(Mutations.SET_PROVEEDOR, data);
      })
      .catch(({ response }) => {
        this.context.commit(
          Mutations.SET_PROVEEDOR_ERROR,
          response.data.errors
        );
        throw new Error();
      });
  }

  @Action
  [Actions.UPD_EMAIL_PROVEEDOR](params) {
    return ApiService.put(`proveedor/v1/proveedor/${params.id}/email`, params)
      .then()
      .catch(({ response }) => {
        this.context.commit(
          Mutations.SET_PROVEEDOR_ERROR,
          response.data.errors
        );
      });
  }

  @Action
  [Actions.UPD_CONTRASENA_PROVEEDOR](params) {
    return ApiService.put(
      `proveedor/v1/proveedor/${params.id}/contrasena`,
      params
    )
      .then()
      .catch(({ response }) => {
        this.context.commit(
          Mutations.SET_PROVEEDOR_ERROR,
          response.data.errors
        );
        throw new Error();
      });
  }

  @Action
  [Actions.CREATE_SOLICITUD_PROVEEDOR](values) {
    return ApiService.postBlob("/Proveedor/v1/crear/solicitud", values)
      .then(({ data }) => {
        this.context.commit(Mutations.SET_GROUP, data);
        return data;
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.SET_GROUP_ERROR, response.data.errors);
        throw new Error();
      });
  }
  @Action
  [Actions.SUBIR_DOCUMENTO_BANCO](values) {
    return ApiService.postBlob("/Proveedor/v1/proveedor/cargarDocumento", values)
      .then(( data ) => {
        this.context.commit(Mutations.SET_GROUP, data);
        return data;
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.SET_GROUP_ERROR, response.data.errors);
        throw new Error();
      });
  }
  @Action
  [Actions.DESCARGAR_DOCUMENTO_BANCO](id) {
    return ApiService.get(`/Proveedor/v1/proveedor/descargarDocumento/${id}`)
      .then(({ data }) => {
    
        return data;
      })
      .catch(({ response }) => {
        this.context.commit(
          Mutations.SET_PROVEEDOR_ERROR,
          response.data.errors
        );

        throw new Error();
      });
  }
}
